import router from '@/router';

const getRepoId = (connector: string = '%2F', namespace: string | string[] = '', routeName: string | string[] = '') => {
  let repoId = '';
  const routeParams = router.currentRoute.value.params;
  let routeNamespace = namespace || routeParams.namespace;
  const routeRepoName = routeName || routeParams.repoName;
  if (!routeNamespace || !routeRepoName) return '';
  if (!namespace) {
    routeNamespace = `${connector}${routeNamespace}`;
  }
  // 实际上namespace只有一个，有多个有自组织的项目是特例，项目的id应该是namespace+reponame，gh_mirrors的镜像项目需要拼接gh_mirrors
  repoId = `${routeNamespace}${connector}${routeRepoName}`;
  return repoId;
};

export default getRepoId;
